import axiosInstance from "@/api/axios-instance";
import { UpdateFormMappingRequest } from "@/pages/forms/types/form";

// Replace a form's semantic field mapping. Whole-map replace: semantic fields
// absent from field_mapping become unmapped, so unselected rows are omitted.
export async function updateFormMapping(
  id: string,
  data: UpdateFormMappingRequest,
) {
  const response = await axiosInstance.patch(`/forms/mapping/${id}`, data);
  return response.data;
}
